/**
 * @version: v2.0.0-1
 * @author: Keval Bhatt
 * @copyright: Copyright (c) 2015 Keval Bhatt. All rights reserved.
 * @license: Licensed under the MIT license. See http://www.opensource.org/licenses/mit-license.php
 * @website: http://kevalbhatt.github.io/timezone-picker/
 */

import * as $ from "jquery";

const findValue = function(key, value, data) {
  var referObj = [];
  data.filter(function(object) {
    if (object[key] === value) {
      referObj.push($.extend(true, {}, object));
      return object;
    }
  });
  for (var i = 0; i < referObj.length; i++) {
    delete referObj[i].points;
    delete referObj[i].pin;
  }
  return referObj;
};

/**
 * [generateElement description]
 * @param  {[Jquery Object]}  element     [selector]
 * @param  {[type]}  attr [description]
 * @param  {[javascript Object or text]}  children      [If we pass javascript object or  array it will append all children and if you pass string it will add string(value) inside element ]
 * @param  {Boolean} isSvg       [If it is svg then it will create svg element]
 * @return {[type]}              [description]
 */
const generateElement = function({ element, attr, children = false, isSvg = false }) {
  let elementObject;
  if (isSvg) {
    elementObject = document.createElementNS("http://www.w3.org/2000/svg", element);
  } else {
    elementObject = document.createElement(element);
  }
  if (attr) {
    for (var key in attr) {
      elementObject.setAttribute(key, attr[key]);
    }
  }
  if (children) {
    if (children instanceof Array) {
      for (var idx in children) {
        if (typeof children[idx] !== "function") {
          elementObject.appendChild(children[idx]);
        }
      }
    } else if (typeof children === "string") {
      elementObject.innerHTML = children;
    } else {
      elementObject.appendChild(children);
    }
  }
  return elementObject;
};

export { generateElement, findValue };
